import { render, staticRenderFns } from "./SentimentItem.vue?vue&type=template&id=ec4f2624&scoped=true&"
import script from "./SentimentItem.vue?vue&type=script&lang=js&"
export * from "./SentimentItem.vue?vue&type=script&lang=js&"
import style0 from "./SentimentItem.vue?vue&type=style&index=0&id=ec4f2624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4f2624",
  null
  
)

export default component.exports